import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const VatDetailsModal = ({ show, setShow }) => {
    const { t } = useTranslation();
    return (
        <Modal
            centered
            show={show.showVatDetails}
            onHide={() => setShow((prevState) => ({ ...prevState, showVatDetails: false }))}
        >
            <Modal.Header>
                <Modal.Title>{t('VAT')}</Modal.Title>
                <AiOutlineClose
                    className="ml-auto cursor-pointer"
                    size={24}
                    onClick={() => setShow((prevState) => ({ ...prevState, showVatDetails: false }))}
                />
            </Modal.Header>
            <Modal.Body>
                <p>
                    {t(
                        `The Swedish Tax Agency's main rule is that goods and services invoiced within Sweden have a VAT surcharge of 25%. However, there are a few exceptional cases where the tax rate can be 12%, 6% or 0%.
                     Examples of extraordinary circumstances with 6% VAT are copyrighted material.
             Exports, work in international waters, CSN-eligible education, and certain types of healthcare are VAT exempt. Artist and musician gages have a 25% VAT surcharge, except when the artist or musician owns the invoicing company, in which case the gages are VAT exempt. If you are unsure which VAT rate applies to your work, don't hesitate to contact us at`
                    )}
                    <a href="mailto:support@invozio.com">
                        <u> support@invozio.com</u>
                    </a>
                </p>
            </Modal.Body>
        </Modal>
    );
};

export default VatDetailsModal;